import Button from '@Components/Buttons/Button'
import { ICONS } from '@Const/common'
import FilterPills from '@Components/Search/SearchPanel/FilterPills'
import SortBy from '@Components/Search/SearchPanel/SortBy'
import React from 'react'
import { FilterValues, SearchPanelSortOption } from '@Components/Search/SearchPanel/types'
import { FilterFieldGroup } from '@App/forms/common/filter-field-group'
import { buildFilterSummary } from '@Components/Search/SearchPanel/FilterControls/build-filter-summary'

interface FilterControlsProps<K extends object> {
    filterFieldCollections?: Array<FilterFieldGroup<K>>
    setIsSidebarOpen: (isOpen: boolean) => void
    filterCount: number
    sortOptions?: SearchPanelSortOption[]
    sortValue?: string
    onSortChange?: (value: string) => void
    /** Excludes this field from the pill summary; it has its own dedicated SortBy control instead. */
    sortFilterKey?: string
    /** The filters currently applied to the search (i.e. Applied/Reset), not the sidebar's draft edits. */
    appliedFilterValues?: FilterValues<K>
    /** Applies a new set of filter values, e.g. after a pill is removed. */
    onRemoveFilter: (filters: FilterValues<K> | undefined) => void
}

const FilterControls = <K extends object>({
    filterFieldCollections,
    setIsSidebarOpen,
    filterCount,
    sortOptions,
    sortValue,
    onSortChange,
    sortFilterKey,
    appliedFilterValues,
    onRemoveFilter,
}: FilterControlsProps<K>) => {
    const activeFilterPills = buildFilterSummary(
        filterFieldCollections,
        appliedFilterValues as Record<string, unknown> | undefined,
        onRemoveFilter,
        sortFilterKey
    )

    const hasFilterFields = !!filterFieldCollections?.length
    const hasSortOptions = !!sortOptions?.length

    return (
        <div className="sidebar-button-row">
            {hasFilterFields && (
                <div className="filter-controls">
                    <Button
                        type="secondary"
                        className="sidebar-button"
                        onClick={() => {
                            setIsSidebarOpen(true)
                        }}
                        mainColor
                        submitType="button"
                    >
                        <>
                            <span className="button-text">Filters ({filterCount})</span>
                            <img alt="filter" src={ICONS.filter} />
                        </>
                    </Button>
                    <FilterPills activeFilterPills={activeFilterPills} />
                </div>
            )}
            {hasSortOptions && <SortBy sortValue={sortValue} sortOptions={sortOptions} onSortChange={onSortChange} />}
        </div>
    )
}

export default FilterControls
